// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"413e4a87","407":"413e4a87","574":"413e4a87"}[chunkId] + ".chunk.css";
};